import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import Particles from "src/views/components/Particles/Particles";

/** Darker navy/slate — visible on light canvas without neon glow */
const LOGIN_PARTICLE_COLORS = ["#1E3A5F", "#172E4D", "#2A4A6F", "#4A6B8A", "#1A2332"];

function LoginStaticBackground() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        background: "linear-gradient(165deg, #FAFBFC 0%, #F0F2F5 50%, #E8EEF5 100%)",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          opacity: 0.7,
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(30, 58, 95, 0.12) 1px, transparent 0)",
          backgroundSize: "28px 28px",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse 80% 60% at 50% 40%, rgba(30, 58, 95, 0.06), transparent 70%)",
        },
      }}
    />
  );
}

/**
 * Login-only background: React Bits Particles (free JS-CSS) or static fallback.
 * Respects prefers-reduced-motion — no WebGL when reduced motion is requested.
 */
function LoginParticlesBackground() {
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  if (prefersReducedMotion) {
    return <LoginStaticBackground />;
  }

  const pixelRatio =
    typeof window !== "undefined" ? Math.min(window.devicePixelRatio || 1, 2) : 1;

  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        bgcolor: "#FAFBFC",
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.88,
        }}
      >
        <Particles
          particleCount={150}
          particleSpread={9}
          speed={0.09}
          particleColors={LOGIN_PARTICLE_COLORS}
          moveParticlesOnHover={false}
          alphaParticles
          particleBaseSize={72}
          sizeRandomness={0.55}
          cameraDistance={22}
          disableRotation={false}
          pixelRatio={pixelRatio}
        />
      </Box>
      {/* Light veil only — keeps card readable without hiding particles */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(250, 251, 252, 0.08) 0%, rgba(250, 251, 252, 0.28) 100%)",
        }}
      />
    </Box>
  );
}

export default LoginParticlesBackground;
